import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-ice px-4 py-5 sm:px-6" data-id="element-70" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl gap-3 rounded-xl border border-turq/40 bg-white p-3.5 shadow-sm" data-id="element-71" data-mp="1o3dmwcdeadr5">
        <ShieldCheckIcon className="h-9 w-9 shrink-0 text-turq" strokeWidth={1.8} aria-hidden="true" data-id="element-72" data-mp="221bwz5kono0u" />
        <div data-id="element-73" data-mp="19e7pmty4axlw">
          <h2 className="font-heading text-[0.95rem] font-extrabold uppercase text-deep sm:text-xl" data-id="element-74" data-mp="19fskkkocgika">
            Your purchase is 100% protected
          </h2>
          <p className="mt-1 text-[0.86rem] leading-snug text-muted sm:text-base" data-id="element-75" data-mp="1j4k8mhqaaipx">
            Explore OPHTHALMOLOGY VISUAL ATLAS™ for 7 days. Discover the six
            modules, OCT patterns, fundus references, optic nerve visuals,
            visual fields, corneal imaging resources, multimodal tools and five
            professional bonuses. If the system isn’t right for you, contact us
            within 7 days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}